import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../../layouts/Header';
import { 
  ArrowLeft, 
  BarChart, 
  People, 
  Cart, 
  Person, 
  PieChart, 
  Tag, 
  Calendar, 
  CurrencyDollar, 
  Box, 
  ListUl, 
  Clipboard, 
  Shop,
  Box2,
  CartX,
  Bank,
  Archive,
  CartCheck
} from 'react-bootstrap-icons';
import { useSelector } from 'react-redux';

const AllReports = () => {

    const currentSkin = localStorage.getItem("skin-mode") ? "dark" : ""; 
    const [skin, setSkin] = useState(currentSkin);
    
    const navigate = useNavigate();
    const [selectedReport, setSelectedReport] = useState(null);
    const [selectedTransaction, setSelectedTransaction] = useState(null);
    const [dataLoading, setDataLoading] = useState(false);
    const { access } = useSelector((state) => state.login);

    console.log("Access In Reports :", access);
    
    // Map API access keys to report paths
    const accessToReportMap = {
        "CustomerReport:get": "/reports/customer-reports",
        "OrdersReport:get": "/reports/order-reports",
        "KioskUserReport:get": "/reports/kiosk-user-reports",
        "UserAnalyticsReport:get": "/reports/user-analytics-reports",
        "ProductSalesReport:get": "/reports/product-sales-report",
        "ItemWiseReport:get": "/reports/item-wise-report",
        "AddonSalesReport:get": "/reports/addon-sales-report",
        "CouponsReport:get": "/reports/coupons-report",
        "DaySummaryReport:get": "/reports/day-summary-report",
        "MonthSummaryReport:get": "/reports/month-summary-report",
        "OutletStockReport:get": "/reports/outlet-stock-report",
        "StorageLocationStockReport:get": "/reports/storage-location-stock-report",
        "UserCouponReport:get": "/reports/user-coupon-report",
        "RMReorderReport:get": "/reports/rm-reorder-report",
        "OutOfStockProductReport:get": "/reports/out-of-stock-product-report",
        "RMCentralStockReport:get": "/reports/out-of-stock-product-report", // Note: This seems to be mapped to the same path as above
        "SubscriptionPurchaseReport:get": "/subscription/subscription-users",
        "SubscriptionConsumptionReport:get": "/subscription/subscription-consumption-report"
    };

    const allReports = [
        { path: "/reports/customer-reports", name: "Customer Report", icon: <People size={20} />, color: "#4e73df", accessKey: "CustomerReport:get" },
        { path: "/reports/order-reports", name: "Order Report", icon: <Cart size={20} />, color: "#1cc88a", accessKey: "OrdersReport:get" },
        { path: "/reports/kiosk-user-reports", name: "Kiosk User Report", icon: <Person size={20} />, color: "#36b9cc", accessKey: "KioskUserReport:get" },
        { path: "/reports/user-analytics-reports", name: "User Analytics Report", icon: <PieChart size={20} />, color: "#f6c23e", accessKey: "UserAnalyticsReport:get" },
        { path: "/reports/product-sales-report", name: "Product Sales Report", icon: <CurrencyDollar size={20} />, color: "#4e73df", accessKey: "ProductSalesReport:get" },
        { path: "/reports/item-wise-report", name: "Item Wise Report", icon: <ListUl size={20} />, color: "#36b9cc", accessKey: "ItemWiseReport:get" },
        { path: "/reports/addon-sales-report", name: "Addon Sales Report", icon: <Clipboard size={20} />, color: "#e74a3b", accessKey: "AddonSalesReport:get" },
        { path: "/reports/coupons-report", name: "Coupons Report", icon: <Tag size={20} />, color: "#e74a3b", accessKey: "CouponsReport:get" },
        { path: "/reports/day-summary-report", name: "Day Summary", icon: <Calendar size={20} />, color: "#5a5c69", accessKey: "DaySummaryReport:get" },
        { path: "/reports/month-summary-report", name: "Month Summary", icon: <Calendar size={20} />, color: "#858796", accessKey: "MonthSummaryReport:get" },
        { path: "/reports/user-coupon-report", name: "User Coupon Report", icon: <Tag size={20} />, color: "#1cc88a", accessKey: "UserCouponReport:get" },
        
        { path: "/reports/rm-reorder-report", name: "RM Reorder Level", icon: <Box size={20} />, color: "#f6c23e", accessKey: "RMReorderReport:get" },
        { path: "/reports/out-of-stock-product-report", name: "Product Out Of Stock Report", icon: <CartX size={20} />, color: "#e74a3b", accessKey: "OutOfStockProductReport:get" },
        
        { path: "/reports/outlet-stock-report", name: "Outlet Stock Report", icon: <Shop size={20} />, color: "#e74a3b", accessKey: "OutletStockReport:get" },
        { path: "/reports/storage-location-stock-report", name: "Storage Location Stock Report", icon: <Box2 size={20} />, color: "#e74a3b", accessKey: "StorageLocationStockReport:get" },
        
        { path: "/reports/stock-consumption-report", name: "Stock Consumption Report", icon: <Calendar size={20} />, color: "#858796", accessKey: "StockConsumptionReport:get" },
        { path: "/reports/rm-stock-report", name: "RM Central Stock Report", icon: <Archive size={20} />, color: "#e74a3b", accessKey: "RMCentralStockReport:get" },
        
        { path: "/subscription/subscription-users", name: "Subscription Purchase Report", icon: <CartCheck size={20} />, color: "#1cc88a", accessKey: "SubscriptionPurchaseReport:get" },
        { path: "/subscription/subscription-consumption-report", name: "Subscription Consumption Report", icon: <BarChart size={20} />, color: "#5a5c69", accessKey: "SubscriptionConsumptionReport:get" },
    ];

    const transactions = [
        { path: "/transaction/central-stock-report", name: "Central Stock Transactions", icon: <Bank size={20} />, color: "#e74a3b", accessKey: "CentralStockTransaction:get" },
        { path: "/transaction/outlet-stock-report", name: "Outlet Stock Transactions", icon: <Archive size={20} />, color: "#e74a3b", accessKey: "OutletStockTransaction:get" }
    ];

    // Filter reports based on user access
    // If userAccess is null (empty dbResponse), show all reports
    // If userAccess is an array, filter reports based on access keys
    const filteredReports = access === null || access?.length === 0 || access === undefined
        ? allReports 
        : allReports.filter(report => access?.includes(report?.accessKey));

    const filteredTransactions = access === null || access?.length === 0 || access === undefined
        ? transactions
        : transactions.filter(tran => access?.includes(tran?.accessKey));

    const handleReportClick = (report) => {
        setSelectedReport(report);
        navigate(report.path);
    };

    console.log(filteredTransactions, "filteredTransactionsfilteredTransactions");
    

    const handleTransactionClick = (transaction) => {
        setSelectedTransaction(transaction);
        navigate(transaction.path);
    };

    const handleBackClick = () => {
        setSelectedReport(null);
        setSelectedTransaction(null);
        navigate("/reports/all-reports");
    };

    return (
        <React.Fragment>
            <Header onSkin={setSkin} />
            <div className={`main main-app p-3 p-lg-4 ${skin === "dark" ? "bg-dark text-light" : "bg-light"}`}>
                {selectedReport ? (
                    <div className="report-detail-container">
                        <button 
                            onClick={handleBackClick}
                            className={`btn ${skin === "dark" ? "btn-outline-light" : "btn-outline-dark"} mb-4 d-flex align-items-center`}
                        >
                            <ArrowLeft className="me-2" /> Back to All Reports
                        </button>
                        
                        <div className="d-flex align-items-center mb-4">
                            <div className="report-icon me-3" style={{ backgroundColor: `${selectedReport.color}20`, color: selectedReport.color }}>
                                {selectedReport.icon || <BarChart size={20} />}
                            </div>
                            <h2 className="mb-0">{selectedReport.name}</h2>
                        </div>
                        
                        <div className="report-content mt-4">
                            <div className={`p-4 rounded-3 ${skin === "dark" ? "bg-gray-800" : "bg-white"} shadow-sm`}>
                                <p className="lead">This would be the {selectedReport.name} content</p>
                                <p>In a real implementation, you would render the appropriate component here.</p>
                            </div>
                        </div>
                    </div>
                ) : (
                    <div className="all-reports-container">
                        <div className="d-flex justify-content-between align-items-center mb-4">
                            <h3 className="mb-0">ALL REPORTS</h3>
                            <div className={`badge ${skin === "dark" ? "bg-light text-dark" : "bg-dark text-light"} p-2`}>
                                {filteredReports.length} reports available
                            </div>
                        </div>
                        
                        {filteredReports.length > 0 ? (
                            <div className="row g-4">
                                {filteredReports.map((report, index) => (
                                    <div key={index} className="col-xl-3 col-lg-4 col-md-6">
                                        <div 
                                            className={`card h-100 report-card ${skin === "dark" ? "bg-gray-800 border-gray-700" : "bg-white border-light"} shadow-sm`}
                                            onClick={() => handleReportClick(report)}
                                        >
                                            <div className="card-body">
                                                <div className="d-flex align-items-center">
                                                    <div className="report-icon me-3" style={{ backgroundColor: `${report.color}20`, color: report.color }}>
                                                        {report.icon}
                                                    </div>
                                                    <h5 className="card-title mb-0">{report.name}</h5>
                                                </div>
                                            </div>
                                            <div className={`card-footer ${skin === "dark" ? "bg-gray-700" : "bg-light"} border-0 py-3`}>
                                                <small className={`text-${skin === "dark" ? "light" : "muted"} d-flex align-items-center`}>
                                                    <BarChart className="me-1" size={12} /> View report
                                                </small>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        ) : (
                            <div className={`text-center py-5 ${skin === "dark" ? "text-light" : "text-muted"}`}>
                                <BarChart size={48} className="mb-3" />
                                <h5>No reports available</h5>
                                <p>You don't have access to any reports. Please contact your administrator.</p>
                            </div>
                        )}

                        <hr className='mt-4' />
                        { filteredTransactions?.length > 0 ? (
                            <div>
                                <h5>ALL TRANSACTIONS</h5>    
                            </div>
                        ) : null }
                        

                        <div className='row g-4'>
                            { filteredTransactions?.map((tran, index) => (
                                <div key={index} className="col-xl-6 col-lg-6 col-md-6">
                                    <div 
                                        className={`card h-100 report-card ${skin === "dark" ? "bg-gray-800 border-gray-700" : "bg-white border-light"} shadow-sm`}
                                        onClick={() => handleTransactionClick(tran)}
                                    >
                                        <div className="card-body">
                                            <div className="d-flex align-items-center">
                                                <div className="report-icon me-3" style={{ backgroundColor: `${tran.color}20`, color: tran.color }}>
                                                    {tran.icon}
                                                </div>
                                                <h5 className="card-title mb-0">{tran.name}</h5>
                                            </div>
                                        </div>
                                        <div className={`card-footer ${skin === "dark" ? "bg-gray-700" : "bg-light"} border-0 py-3`}>
                                            <small className={`text-${skin === "dark" ? "light" : "muted"} d-flex align-items-center`}>
                                                <BarChart className="me-1" size={12} /> View Transactions
                                            </small>
                                        </div>
                                    </div>
                                </div>
                            )) }
                        </div>
                    </div>
                )}
            </div>
            
            <style>{`
                .report-card {
                    cursor: pointer;
                    transition: transform 0.2s, box-shadow 0.2s;
                    border-radius: 0.5rem;
                }
                .report-card:hover {
                    transform: translateY(-3px);
                    box-shadow: ${skin === "dark" ? 
                        "0 0.5rem 1.5rem rgba(0, 0, 0, 0.3)" : 
                        "0 0.5rem 1.5rem rgba(0, 0, 0, 0.1)"};
                }
                .report-icon {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    width: 40px;
                    height: 40px;
                    border-radius: 8px;
                    flex-shrink: 0;
                }
                .bg-gray-800 {
                    background-color: #2a3042;
                }
                .bg-gray-700 {
                    background-color: #3a3f51;
                }
                .border-gray-700 {
                    border-color: #3a3f51 !important;
                }
            `}</style>
        </React.Fragment>
    );
};

export default AllReports;








////---------------------------------//////
// import React, { useState } from 'react';
// import { useNavigate } from 'react-router-dom';
// import Header from '../../layouts/Header';
// import { 
//   ArrowLeft, 
//   BarChart, 
//   People, 
//   Cart, 
//   Person, 
//   PieChart, 
//   Tag, 
//   Calendar, 
//   CurrencyDollar, 
//   Box, 
//   ListUl, 
//   Clipboard, 
//   Shop,
//   Box2,
//   CartX,
//   Bank,
//   Archive,
//   FileText,
//   GraphUp,
//   PersonLinesFill,
//   ClipboardData,
//   Boxes,
//   CashStack,
//   ChevronDown,
//   ChevronRight,
//   Search
// } from 'react-bootstrap-icons';

// const AllReports = () => {
//     const currentSkin = localStorage.getItem("skin-mode") ? "dark" : ""; 
//     const [skin, setSkin] = useState(currentSkin);
//     const navigate = useNavigate();
//     const [selectedReport, setSelectedReport] = useState(null);
//     const [selectedTransaction, setSelectedTransaction] = useState(null);
//     const [expandedCategories, setExpandedCategories] = useState({
//         'SALES & ORDERS': false,
//         'CUSTOMERS & USERS': false,
//         'INVENTORY & STOCKS': false,
//         'COUPONS / DISCOUNT': false,
//         'SUBSCRIPTION': false,
//         'STOCK TRANSACTIONS': false
//     });
//     const [searchQuery, setSearchQuery] = useState('');

//     // Organized reports by category
//     const reportCategories = [
//         {
//             name: "SALES & ORDERS",
//             icon: <Cart size={20} />,
//             color: "#10b981",
//             gradient: "linear-gradient(135deg, #10b981 0%, #059669 100%)",
//             reports: [
//                 { path: "/reports/order-reports", name: "Order Report", icon: <FileText size={20} /> },
//                 { path: "/reports/product-sales-report", name: "Product Sales", icon: <CurrencyDollar size={20} /> },
//                 { path: "/reports/item-wise-report", name: "Item Wise Sales", icon: <ListUl size={20} /> },
//                 { path: "/reports/addon-sales-report", name: "Addon Sales", icon: <Clipboard size={20} /> },
//                 { path: "/reports/day-summary-report", name: "Day Summary", icon: <Calendar size={20} /> },
//                 { path: "/reports/month-summary-report", name: "Month Summary", icon: <Calendar size={20} /> },
//             ]
//         },
//         {
//             name: "CUSTOMERS & USERS",
//             icon: <People size={20} />,
//             color: "#3b82f6",
//             gradient: "linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)",
//             reports: [
//                 { path: "/reports/customer-reports", name: "Customer Report", icon: <PersonLinesFill size={20} /> },
//                 { path: "/reports/kiosk-user-reports", name: "Kiosk Users", icon: <Person size={20} /> },
//                 { path: "/reports/user-analytics-reports", name: "User Analytics", icon: <GraphUp size={20} /> },
//                 { path: "/reports/user-coupon-report", name: "User Coupons", icon: <Tag size={20} /> },
//             ]
//         },
//         {
//             name: "INVENTORY & STOCKS",
//             icon: <Box size={20} />,
//             color: "#f59e0b",
//             gradient: "linear-gradient(135deg, #f59e0b 0%, #d97706 100%)",
//             reports: [
//                 { path: "/reports/outlet-stock-report", name: "Outlet Stock", icon: <Shop size={20} /> },
//                 { path: "/reports/storage-location-stock-report", name: "Storage Location Stock", icon: <Box2 size={20} /> },
//                 { path: "/reports/rm-reorder-report", name: "RM Reorder Level", icon: <Boxes size={20} /> },
//                 { path: "/reports/out-of-stock-product-report", name: "Out Of Stock", icon: <CartX size={20} /> },
//                 { path: "/reports/out-of-stock-product-report", name: "RM Central Stock", icon: <Bank size={20} /> },
//             ]
//         },
//         {
//             name: "COUPONS / DISCOUNT",
//             icon: <Tag size={20} />,
//             color: "#ef4444",
//             gradient: "linear-gradient(135deg, #ef4444 0%, #dc2626 100%)",
//             reports: [
//                 { path: "/reports/coupons-report", name: "Coupons Report", icon: <Tag size={20} /> },
//                 { path: "/reports/user-coupon-report", name: "User Coupon Usage", icon: <CashStack size={20} /> },
//             ]
//         },
//         {
//             name: "SUBSCRIPTION",
//             icon: <Archive size={20} />,
//             color: "#8b5cf6",
//             gradient: "linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%)",
//             reports: [
//                 { path: "/subscription/subscription-users", name: "Purchase Report", icon: <Tag size={20} /> },
//                 { path: "/subscription/subscription-consumption-report", name: "Consumption Report", icon: <CashStack size={20} /> },
//             ]
//         }
//     ];

//     const transactions = [
//         { path: "/transaction/central-stock-report", name: "Central Stock Transactions", icon: <Bank size={20} />, color: "#06b6d4", gradient: "linear-gradient(135deg, #06b6d4 0%, #0891b2 100%)" },
//         { path: "/transaction/outlet-stock-report", name: "Outlet Stock Transactions", icon: <Archive size={20} />, color: "#06b6d4", gradient: "linear-gradient(135deg, #06b6d4 0%, #0891b2 100%)" }
//     ];

//     const toggleCategory = (categoryName) => {
//         setExpandedCategories(prev => ({
//             ...prev,
//             [categoryName]: !prev[categoryName]
//         }));
//     };

//     const handleReportClick = (report) => {
//         setSelectedReport(report);
//         navigate(report.path);
//     };

//     const handleTransactionClick = (transaction) => {
//         setSelectedTransaction(transaction);
//         navigate(transaction.path);
//     };

//     const handleBackClick = () => {
//         setSelectedReport(null);
//         setSelectedTransaction(null);
//         navigate("/reports/all-reports");
//     };

//     // Filter reports based on search query
//     const filteredCategories = reportCategories.map(category => ({
//         ...category,
//         reports: category.reports.filter(report => 
//             report.name.toLowerCase().includes(searchQuery.toLowerCase())
//         )
//     })).filter(category => category.reports.length > 0);

//     const filteredTransactions = transactions.filter(transaction => 
//         transaction.name.toLowerCase().includes(searchQuery.toLowerCase())
//     );

//     return (
//         <React.Fragment>
//             <Header onSkin={setSkin} />
//             <div className={`main main-app p-3 p-lg-4 ${skin === "dark" ? "bg-dark text-light" : "bg-light"}`}>
//                 {selectedReport ? (
//                     <div className="report-detail-container">
//                         <button 
//                             onClick={handleBackClick}
//                             className={`btn ${skin === "dark" ? "btn-outline-light" : "btn-outline-dark"} mb-4 d-flex align-items-center`}
//                         >
//                             <ArrowLeft className="me-2" /> Back to All Reports
//                         </button>
                        
//                         <div className="d-flex align-items-center mb-4">
//                             <div className="report-icon me-3" style={{ background: selectedReport.gradient, color: 'white' }}>
//                                 {selectedReport.icon || <BarChart size={20} />}
//                             </div>
//                             <h2 className="mb-0">{selectedReport.name}</h2>
//                         </div>
                        
//                         <div className="report-content mt-4">
//                             <div className={`p-4 rounded-3 ${skin === "dark" ? "bg-gray-800" : "bg-white"} shadow-sm`}>
//                                 <p className="lead">This would be the {selectedReport.name} content</p>
//                                 <p>In a real implementation, you would render the appropriate component here.</p>
//                             </div>
//                         </div>
//                     </div>
//                 ) : (
//                     <div className="all-reports-container">
//                         <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap">
//                             <div>
//                                 <h2 className="mb-1 fw-bold">Reports Dashboard</h2>
//                                 <p className={`mb-0 ${skin === "dark" ? "text-light" : "text-muted"}`}>
//                                     Access all your business reports in one place
//                                 </p>
//                             </div>
//                             <div className={`badge ${skin === "dark" ? "bg-gray-700" : "bg-light"} p-2 px-3 rounded-pill d-flex align-items-center mt-2 mt-md-0`}>
//                                 <BarChart size={16} className="me-2" />
//                                 {reportCategories.reduce((acc, category) => acc + category.reports.length, 0)} reports available
//                             </div>
//                         </div>

//                         {/* Search Bar */}
//                         {/* <div className={`input-group mb-4 ${skin === "dark" ? "dark-search" : ""}`}>
//                             <span className={`input-group-text ${skin === "dark" ? "bg-gray-700 border-gray-600 text-light" : "bg-light"}`}>
//                                 <Search size={18} />
//                             </span>
//                             <input
//                                 type="text"
//                                 className={`form-control ${skin === "dark" ? "bg-gray-700 border-gray-600 text-light" : ""}`}
//                                 placeholder="Search reports..."
//                                 value={searchQuery}
//                                 onChange={(e) => setSearchQuery(e.target.value)}
//                             />
//                         </div> */}
                        
//                         {/* Categories with reports */}
//                         {filteredCategories.map((category, catIndex) => (
//                             <div key={catIndex} className="mb-4">
//                                 <div 
//                                     className="d-flex align-items-center mb-3 cursor-pointer p-3 rounded-3 category-header"
//                                     onClick={() => toggleCategory(category.name)}
//                                     style={{ 
//                                         background: skin === "dark" ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.03)',
//                                         transition: 'all 0.3s ease'
//                                     }}
//                                 >
//                                     <div className="report-icon me-3" style={{ background: category.gradient, color: 'white' }}>
//                                         {category.icon}
//                                     </div>
//                                     <h5 className="mb-0 flex-grow-1 fw-semibold">{category.name}</h5>
//                                     <span className={`badge me-3 ${skin === "dark" ? "bg-gray-700" : "bg-light"}`}>
//                                         {category.reports.length} reports
//                                     </span>
//                                     {expandedCategories[category.name] ? 
//                                         <ChevronDown size={18} /> : 
//                                         <ChevronRight size={18} />
//                                     }
//                                 </div>
                                
//                                 {expandedCategories[category.name] && (
//                                     <div className="row g-3">
//                                         {category.reports.map((report, reportIndex) => (
//                                             <div key={reportIndex} className="col-xl-4 col-lg-4 col-md-6">
//                                                 <div 
//                                                     className={`card h-100 report-card ${skin === "dark" ? "bg-gray-800 border-gray-700" : "bg-white border-light"} shadow-sm`}
//                                                     onClick={() => handleReportClick({...report, color: category.color, gradient: category.gradient})}
//                                                 >
//                                                     <div className="card-body">
//                                                         <div className="d-flex align-items-start">
//                                                             <div className="report-icon me-3 mt-1" style={{ backgroundColor: `${category.color}15`, color: category.color }}>
//                                                                 {report.icon}
//                                                             </div>
//                                                             <div>
//                                                                 <h6 className="card-title mb-1 fw-semibold">{report.name}</h6>
//                                                                 <small className={`${skin === "dark" ? "text-light" : "text-muted"}`}>
//                                                                     Detailed analysis and insights
//                                                                 </small>
//                                                             </div>
//                                                         </div>
//                                                     </div>
//                                                     <div className={`card-footer ${skin === "dark" ? "bg-gray-700" : "bg-light"} border-0 py-3 d-flex justify-content-between align-items-center`}>
//                                                         <small className={`text-${skin === "dark" ? "light" : "muted"} d-flex align-items-center`}>
//                                                             <BarChart className="me-1" size={12} /> View report
//                                                         </small>
//                                                         <div 
//                                                             className="rounded-circle d-flex align-items-center justify-content-center"
//                                                             style={{ width: '24px', height: '24px', backgroundColor: `${category.color}20`, color: category.color }}
//                                                         >
//                                                             <ChevronRight size={12} />
//                                                         </div>
//                                                     </div>
//                                                 </div>
//                                             </div>
//                                         ))}
//                                     </div>
//                                 )}
//                             </div>
//                         ))}

//                         {/* Transactions Section */}
//                         {filteredTransactions.length > 0 && (
//                             <div className="mb-5">
//                                 <div 
//                                     className="d-flex align-items-center mb-3 cursor-pointer p-3 rounded-3 category-header"
//                                     onClick={() => toggleCategory('STOCK TRANSACTIONS')}
//                                     style={{ 
//                                         background: skin === "dark" ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.03)',
//                                         transition: 'all 0.3s ease'
//                                     }}
//                                 >
//                                     <div className="report-icon me-3" style={{ background: "linear-gradient(135deg, #06b6d4 0%, #0891b2 100%)", color: 'white' }}>
//                                         <ClipboardData size={20} />
//                                     </div>
//                                     <h5 className="mb-0 flex-grow-1 fw-semibold">STOCK TRANSACTIONS</h5>
//                                     <span className={`badge me-3 ${skin === "dark" ? "bg-gray-700" : "bg-light"}`}>
//                                         {transactions.length} reports
//                                     </span>
//                                     {expandedCategories['STOCK TRANSACTIONS'] ? 
//                                         <ChevronDown size={18} /> : 
//                                         <ChevronRight size={18} />
//                                     }
//                                 </div>
                                
//                                 {expandedCategories['STOCK TRANSACTIONS'] && (
//                                     <div className='row g-3'>
//                                         {filteredTransactions.map((tran, index) => (
//                                             <div key={index} className="col-xl-6 col-lg-6 col-md-6">
//                                                 <div 
//                                                     className={`card h-100 report-card ${skin === "dark" ? "bg-gray-800 border-gray-700" : "bg-white border-light"} shadow-sm`}
//                                                     onClick={() => handleTransactionClick(tran)}
//                                                 >
//                                                     <div className="card-body">
//                                                         <div className="d-flex align-items-start">
//                                                             <div className="report-icon me-3 mt-1" style={{ backgroundColor: 'rgba(6, 182, 212, 0.15)', color: '#06b6d4' }}>
//                                                                 {tran.icon}
//                                                             </div>
//                                                             <div>
//                                                                 <h6 className="card-title mb-1 fw-semibold">{tran.name}</h6>
//                                                                 <small className={`${skin === "dark" ? "text-light" : "text-muted"}`}>
//                                                                     Track inventory movements and changes
//                                                                 </small>
//                                                             </div>
//                                                         </div>
//                                                     </div>
//                                                     <div className={`card-footer ${skin === "dark" ? "bg-gray-700" : "bg-light"} border-0 py-3 d-flex justify-content-between align-items-center`}>
//                                                         <small className={`text-${skin === "dark" ? "light" : "muted"} d-flex align-items-center`}>
//                                                             <BarChart className="me-1" size={12} /> View Transactions
//                                                         </small>
//                                                         <div 
//                                                             className="rounded-circle d-flex align-items-center justify-content-center"
//                                                             style={{ width: '24px', height: '24px', backgroundColor: 'rgba(6, 182, 212, 0.15)', color: '#06b6d4' }}
//                                                         >
//                                                             <ChevronRight size={12} />
//                                                         </div>
//                                                     </div>
//                                                 </div>
//                                             </div>
//                                         ))}
//                                     </div>
//                                 )}
//                             </div>
//                         )}

//                         {/* No results message */}
//                         {filteredCategories.length === 0 && filteredTransactions.length === 0 && searchQuery && (
//                             <div className="text-center py-5">
//                                 <div className={`rounded-circle d-inline-flex align-items-center justify-content-center mb-3 ${skin === "dark" ? "bg-gray-800" : "bg-light"}`} style={{width: '80px', height: '80px'}}>
//                                     <Search size={30} className={skin === "dark" ? "text-light" : "text-muted"} />
//                                 </div>
//                                 <h5>No reports found</h5>
//                                 <p className={skin === "dark" ? "text-light" : "text-muted"}>
//                                     No reports match your search for "{searchQuery}". Try different keywords.
//                                 </p>
//                             </div>
//                         )}
//                     </div>
//                 )}
//             </div>
            
//             <style>{`
//                 .report-card {
//                     cursor: pointer;
//                     transition: all 0.3s ease;
//                     border-radius: 0.75rem;
//                     border: none;
//                     overflow: hidden;
//                 }
//                 .report-card:hover {
//                     transform: translateY(-5px);
//                     box-shadow: ${skin === "dark" ? 
//                         "0 1rem 2rem rgba(0, 0, 0, 0.25)" : 
//                         "0 1rem 2rem rgba(0, 0, 0, 0.1)"};
//                 }
//                 .report-icon {
//                     display: flex;
//                     align-items: center;
//                     justify-content: center;
//                     width: 40px;
//                     height: 40px;
//                     border-radius: 10px;
//                     flex-shrink: 0;
//                     transition: all 0.3s ease;
//                 }
//                 .bg-gray-800 {
//                     background-color: #2a3042;
//                 }
//                 .bg-gray-700 {
//                     background-color: #3a3f51;
//                 }
//                 .border-gray-700 {
//                     border-color: #3a3f51 !important;
//                 }
//                 .cursor-pointer {
//                     cursor: pointer;
//                 }
//                 .flex-grow-1 {
//                     flex-grow: 1;
//                 }
//                 .category-header:hover {
//                     background: ${skin === "dark" ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.05)'} !important;
//                 }
//                 .dark-search input::placeholder {
//                     color: #adb5bd;
//                 }
//                 .dark-search input {
//                     color: #f8f9fa;
//                 }
//             `}</style>
//         </React.Fragment>
//     );
// };

// export default AllReports;